var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFrame = function SvgFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 246,
    height: 246,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    stroke: "#fff",
    strokeWidth: 6,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.154 3H21.46A18.462 18.462 0 0 0 3 21.462v27.692M196.846 3h27.692A18.462 18.462 0 0 1 243 21.462v27.692M49.154 243H21.46A18.462 18.462 0 0 1 3 224.538v-27.692M196.846 243h27.692A18.462 18.462 0 0 0 243 224.538v-27.692"
  }))));
};
export default SvgFrame;